module.exports = __webpack_public_path__ + "static/media/tk.cf32b270.svg";